import { CalendarDay } from '../body/CalendarBody.types';

function isDayUnavailableByCheckIn(entry: CalendarDay) {
  const notes = entry.notes ?? [];
  return (
    notes.filter((t) => t.startsWith('BLOCK_START')).length > 0 ||
    notes.filter((t) => t.startsWith('CHECK_IN_BOOKING')).length > 0 ||
    notes.filter((t) => t.startsWith('CHECK_IN_INQUIRY')).length > 0
  );
}

function isDayUnavailableByBookingOrInquiry(entry: CalendarDay) {
  const notes = entry.notes ?? [];
  return (
    notes.filter((t) => t.startsWith('BLOCK')).length > 0 ||
    notes.filter((t) => t.startsWith('BOOKING')).length > 0 ||
    notes.filter((t) => t.startsWith('INQUIRY')).length > 0
  );
}

function isCheckoutNotAllowedDueToBookingCheckout(entry: CalendarDay) {
  const notes = entry.notes ?? [];
  return (
    !entry.availableForCheckout &&
    notes.filter(
      (t) => t.startsWith('CHECK_OUT_BOOKING') || t.startsWith('BLOCK_END'),
    ).length > 0
  );
}

function isATurnoverDay(entry: CalendarDay) {
  return (
    !entry.availableForCheckIn &&
    entry.notes &&
    entry.notes.filter((t) => t.startsWith('Turnover')).length > 0 &&
    !isDayUnavailableByCheckIn(entry) &&
    !isDayUnavailableByBookingOrInquiry(entry)
  );
}

const useDayCellIconsVisibility = (calendarDay: CalendarDay) => {
  const isTurnoverIconVisible = isATurnoverDay(calendarDay);
  const isCheckInBlockedIconVisible = !calendarDay.availableForCheckIn;
  const isCheckoutBlockedIconVisible =
    !calendarDay.availableForCheckout &&
    !calendarDay.notes?.filter((s) => s.startsWith('Turnover')).length &&
    !isCheckoutNotAllowedDueToBookingCheckout(calendarDay);

  return {
    isTurnoverIconVisible,
    isCheckInBlockedIconVisible,
    isCheckoutBlockedIconVisible,
  };
};

export default useDayCellIconsVisibility;
